import { render, staticRenderFns } from "./EnsembleCategory.vue?vue&type=template&id=0591523c"
import script from "./EnsembleCategory.vue?vue&type=script&lang=js"
export * from "./EnsembleCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projects\\MDA\\schoolofmusic-ucla\\web\\app\\themes\\ucla\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0591523c')) {
      api.createRecord('0591523c', component.options)
    } else {
      api.reload('0591523c', component.options)
    }
    module.hot.accept("./EnsembleCategory.vue?vue&type=template&id=0591523c", function () {
      api.rerender('0591523c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/components/EnsembleCategory.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/EnsembleCategory.vue
// module id = 381
// module chunks = 0